'use strict';

var _ = require('lodash');

SwaggerEditor.controller('GitlabUpdateCtrl', function GitlabUpdateCtrl($scope,
  $uibModalInstance, $localStorage,
  $rootScope, $state, GLBackend, Storage, Preferences) {
  $scope.error = null;
  $scope.commitMessage = null;

  var update = function(commitMessage) {
    $scope.error = null;
    const baseurl = Preferences.get('gitlabBaseUrl');
    const token = Preferences.get('gitlabToken');
    const filepath = $localStorage.Gitlab.metadata.filepath;
    const projectid = $localStorage.Gitlab.metadata.projectid;
    const branchName = $localStorage.Gitlab.metadata.ref;
    var content =
        window.btoa($localStorage.SwaggerEditorCache.yaml)
     // encodeURIComponent()
     ;

    if (_.startsWith(baseurl, 'http')) {
      // $scope.fetching = true;

      var url = baseurl + "/api/v3/projects/" + projectid +
      "/repository/files?file_path=" + encodeURIComponent(filepath) +
      "&branch_name=" + branchName +
      "&encoding=base64" +
      "&commit_message=" + commitMessage +
      "&access_token=" + token;
      GLBackend.commitNow(url, JSON.stringify({
        content: content
      }));
      $state.go('home', {tags: null});
      $uibModalInstance.close();
    } else {
      $scope.error = 'Invalid URL';
    }
  };

  $scope.update = _.throttle(update, 200);

  $scope.cancel = $uibModalInstance.close;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/update-gitlab.js
// module id = 406
// module chunks = 0